<template>
  <div class="warining-list-log">
    <el-row class="header-title"
            type="flex"
            justify="space-between"
            align="middle">
      <div class="title-item">
        <div class="status"
             :class="
            (statusValue == 1 && 'huoyue') ||
              (statusValue == 2 && 'zanting') ||
              (statusValue == 3 && 'siwang')
          ">
          {{ formatStatusVal }}
        </div>
        <div class="customer-name"
             @click="skipDetail">
          {{ serviceDetail.custName }}
        </div>
      </div>
      <div class="title-item title-info">
        <div class="sum">
          账户余额：
          <span v-if="serviceDetail.balance">{{ balance }}</span>
          <span v-else>0</span>
        </div>
      </div>
    </el-row>
    <el-row type="flex"
            justify="start"
            align="middle"
            class="customer-info-list">
      <el-col :span="8"
              v-for="item in customerInfoList"
              :key="item.id">
        <span> {{ item.label }}： </span>
        <span :style="[item.valueSty]"
              @click="customerInfoClick(item)">
          {{ item.value }}
        </span>
      </el-col>
    </el-row>

    <filter-panel :data="groups"
                  @search="filterChange"></filter-panel>
    <data-list :table-style="{ name: 'mixture' }"
               :columns="columns"
               :data="data"
               :page="page"
               :loading="loading"
               :page-size="page.pageSize"
               @page-size-changed="pageSizeChanged"
               @page-changed="pageChanged"
               @sort-change="sortChange"></data-list>
  </div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import formDialog from '@/components/webManage/formDialog.vue';
import { mapActions, mapGetters } from 'vuex';
import customer from '@/mixins/customer';
import barCard from '@/components/customPageCard/barCard';
import { decode } from '@/common/util.js';
import googleAds from '@/backend/services/googleAds/googleAds.js';
import filters from '@/mixins/filters.js';

const dataList = listPageCreate({
  searchConfig: {
    api: api.googleAds.warningLog,
    method: 'POST'
  },
  getQuery (obj, that) {
    if (typeof obj.ruleId == 'undefined') {
      obj.ruleId = that.$route.query.ruleId;
    }
    if (typeof obj.listRuleItemId == 'undefined') {
      obj.listRuleItemId = that.$route.query.ruleItemId;
    }
    const { listRuleItemId } = obj;
    obj.listRuleItemId = listRuleItemId ? [listRuleItemId] : [];
    return _.assign(obj, {
      customerId: that.getQueryParam.customerId,
      serviceId: that.getQueryParam.serviceId
    });
  }
});
export default {
  name: 'warningListLog',
  components: {
    filterPanel,
    formDialog,
    barCard
  },
  mixins: [dataList, customer],
  data () {
    return {
      ruleTypes: [],
      allOperator: [],
      decode,
      serviceDetail: {},
      customerInfoList: [],
      groups: {
        others: [
          {
            tagName: 'sky-cascader',
            placeholder: '全部类型',
            label: '全部类型',
            prop: 'listRuleItemId',
            value: null,
            emptyValue: null,
            props: {
              label: 'name',
              value: 'id',
              children: 'ruleItemVOList'
            },
            checkStrictly: false,
            options: []
          },
          // {
          //   tagName: "sky-select",
          //   placeholder: "预警项",
          //   label: "预警项",
          //   prop: "ruleItemId",
          //   filterable: true,
          //   remote: true,
          //   'remote-method' (query) {
          //     self.queryRules(query)
          //   },
          //   props: {
          //     label: 'name',
          //     value: 'id'
          //   },
          //   value: null,
          //   emptyValue: null,//删除tag时给value赋的值
          //   options: []
          // },
          {
            tagName: 'sky-date-picker',
            type: 'daterange',
            label: '日期',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            prop: ['beginTime', 'endTime'],
            value: [],
            emptyValue: null
          }
        ],
        multiples: [
          {
            defaultText: '日志记录原因',
            placeholder: '日志记录原因',
            label: '日志记录原因',
            prop: 'operationType',
            props: {
              label: 'name',
              value: 'code'
            },
            value: null,
            emptyValue: null,
            options: []
          },
          {
            defaultText: '操作人',
            placeholder: '操作人',
            label: '操作人',
            prop: 'operatorType',
            value: null,
            emptyValue: null,
            options: [
              {
                label: '系统',
                value: '1'
              },
              {
                label: '优化师',
                value: '2'
              }
            ]
          }
        ]
      },
      columns: [
        {
          label: '日期',
          bind: 'createTime'
        },
        {
          label: '预警项',
          bind: 'ruleItemName'
        },
        {
          label: '预警类型',
          bind: 'ruleName'
        },
        {
          label: '日志记录原因',
          bind: 'operationTypeStr'
        },
        {
          label: '操作人',
          bind: 'accountName',
          width: '180px'
        },
        {
          label: '详情',
          type: 'custInfo',
          text: [
            {
              bind: 'details',
              colType: 'transTextFormat',
              custValue (row, bind = 'details') {
                if (row && row[bind] && row[bind].indexOf('</br>')) {
                  return row[bind].split('</br>').join('');
                }
              }
            }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['warningType', 'operatList']),
    statusValue () {
      return this.serviceDetail.activeStatus;
    },
    formatStatusVal () {
      let val = this.serviceDetail.activeStatus;
      switch (val) {
        case 1:
          return '活跃';
        case 2:
          return '暂停';
        case 3:
          return '死亡';
      }
    },
    balance () {
      return filters.filters.rmb(this.serviceDetail.balance);
    },
    getQueryParam () {
      return this.$route.query
    }
  },
  methods: {
    ...mapActions(['getWarningType', 'getOperatList']),
    setGroups () {
      const self = this;
      // 全部类型
      this.groups.others[0].value = self.$route.query.ruleItemId || null;
      this.groups.others[0].options = self.ruleTypes;
      // 日志记录原因
      this.groups.multiples[0].options = self.allOperator;
    },
    setcustomerInfoList (val = {}) {
      this.customerInfoList = [
        {
          id: 1,
          label: '服务人员',
          value: val.serviceStaffName || '-'
        },
        {
          id: 2,
          label: 'CID',
          value: val.cid || '-'
        },
        {
          id: 3,
          label: '订单号',
          value: val.orderCode || '-'
        },
        {
          id: 4,
          label: '服务单号',
          value: val.serviceCode || '-'
        },
        {
          id: 5,
          label: 'CID绑定时间',
          value: val.accountOpenTime || '-'
        },
        {
          id: 7,
          label: '推广网站',
          value: val.domain || '-',
          valueSty: {
            color: '#409eff',
            cursor: 'pointer',
            'user-select': 'none'
          }
        }
      ];
      let status = this.statusValue;
      if (status == 2) {
        this.customerInfoList.push({
          id: 6,
          label: '暂停时间',
          value: val.statusChangeTime || '-'
        });
      }

      if (status == 3) {
        this.customerInfoList.push({
          id: 6,
          label: '死亡时间',
          value: val.statusChangeTime || '-'
        });
      }
    },
    skipDetail () {
      this.$router.push({
        name: 'serviceDefault',
        query: {
          serviceId: this.serviceDetail.serviceId
        }
      });
    },
    customerInfoClick (item) {
      if (item.id == 7) {
        window.open(`//${item.value}`);
      }
    }
  },
  async created () {
    this.ruleTypes =
      this.warningType.length == 0
        ? await this.getWarningType()
        : this.warningType;
    this.allOperator =
      this.operatList.length == 0
        ? await this.getOperatList()
        : this.operatList;
    this.setGroups();
  },
  async mounted () {
    let id = this.$route.query.serviceId;
    let res = await googleAds.serviceDetail(id);
    this.serviceDetail = res.data;
    this.setcustomerInfoList(res.data);
    this.query();
  }
};
</script>

<style lang="scss" scoped>
.log-header {
  color: #333;
}
.service-code {
  strong {
    margin-left: 20px;
    font-size: 18px;
  }
}

.header-title {
  height: 60px;
  padding: 0 10px;
  background-color: #fff;
  .title-item {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .status {
      width: 72px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      font-size: 16px;
      font-weight: normal;
      background-color: #ffce3d;
      border-radius: 4px;
      margin-right: 16px;
      &.huoyue {
        background-color: #188343;
      }
      &.zanting {
        background-color: #757575;
      }
      &.siwang {
        background-color: #c3322a;
      }
    }
    .customer-name {
      color: #409eff;
      user-select: none;
      cursor: pointer;
    }
    .customer-name,
    .sum {
      margin-left: 16px;
      font-size: 22px;
      font-weight: bold;
    }
    .sum {
      font-weight: normal;
      margin-right: 16px;
      color: #333;
    }

    .cutStatus {
      margin-left: 10px;
      font-size: 14px;
      color: #409eff;
      line-height: 20px;
      cursor: pointer;
      user-select: none;
      i {
        font-size: 12px;
      }
    }
  }
  .title-info {
    justify-content: flex-end;
  }
}
.customer-info-list {
  flex-wrap: wrap;
  height: 100px;
  background-color: #fff;
  margin: 10px 0;
  padding: 10px 10px;
}
</style>
